import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { WindowRefService } from '@hdms/shared/util-core';

import { LeftCardComponentAbstract } from '../left-card.component.abstract';

@Component({
  selector: 'shrd-uic-left-card-content',
  templateUrl: './left-card-content.component.html',
  styleUrls: ['./left-card-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeftCardContentComponent extends LeftCardComponentAbstract {
  @Input() scrollbarEnabled = true;
  @Input() id: number;
  @Input() currentCard: number;
  @Input() headerRef: TemplateRef<never>;
  @Input() bodyRef: TemplateRef<never>;
  @Input() footerRef: TemplateRef<never>;

  @ViewChild('cardContentContainer', { static: true }) cardContainer: ElementRef<HTMLDivElement>;
  @ViewChild('scrollContent') scrollContent: ElementRef<HTMLDivElement>;
  @HostBinding('class.shrd-uic-left-card-content') readonly hostClass = true;

  @HostBinding('class.is-overlapped')
  get classIsOverlapped(): boolean {
    return this.currentCard !== this.id;
  }

  public scrollToTargetSelector: string;

  constructor(win: WindowRefService, cdr: ChangeDetectorRef) {
    super(win, cdr);
  }

  reset(): void {
    this.isHidden = true;
  }

  protected override onVisibilityChange(): void {
    if (this.isOpen) {
      this.scrollContent?.nativeElement.scrollTo(0, 0);
    }
    super.onVisibilityChange();
  }
}
